export interface LinkGpsTrackingDeviceToVehicleOutputDto {
    updatedLicensePlates: string[];
    notUpdatedLicensePlates: string[];
}
